import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
//fonts
import './fonts/Cuprum/Cuprum-Bold.ttf';
import './fonts/Cuprum/Cuprum-BoldItalic.ttf';
import './fonts/Cuprum/Cuprum-Italic.ttf';
import './fonts/Cuprum/Cuprum-Medium.ttf';
import './fonts/Cuprum/Cuprum-MediumItalic.ttf';
import './fonts/Cuprum/Cuprum-Regular.ttf';
import './fonts/Cuprum/Cuprum-SemiBold.ttf';
import './fonts/Cuprum/Cuprum-SemiBoldItalic.ttf';



ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
